import { Line } from "react-chartjs-2";
import "../lib/chartSetup";
import { baseLineOptions, chartColors } from "../lib/chartSetup";
import { formatDateTime } from "../lib/format";
import type { HistoryPoint } from "../types";

function labelsFor(history: HistoryPoint[]) {
  return history.map((h) => formatDateTime(h.received_at));
}

export function ProfitTodayChart({ history }: { history: HistoryPoint[] }) {
  const data = {
    labels: labelsFor(history),
    datasets: [
      {
        label: "Profit Today",
        data: history.map((h) => h.today_profit),
        borderColor: chartColors.emerald,
        backgroundColor: "rgba(52, 211, 153, 0.15)",
        fill: true,
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  };
  return (
    <div className="h-64">
      <Line data={data} options={baseLineOptions("USD")} />
    </div>
  );
}

export function FloatingPnLChart({ history }: { history: HistoryPoint[] }) {
  const data = {
    labels: labelsFor(history),
    datasets: [
      {
        label: "Floating",
        data: history.map((h) => h.floating_profit - h.floating_loss),
        borderColor: chartColors.sky,
        backgroundColor: "rgba(56, 189, 248, 0.12)",
        fill: true,
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  };
  return (
    <div className="h-64">
      <Line data={data} options={baseLineOptions("USD")} />
    </div>
  );
}

export function EquityHistoryChart({ history }: { history: HistoryPoint[] }) {
  const data = {
    labels: labelsFor(history),
    datasets: [
      {
        label: "Equity",
        data: history.map((h) => h.equity),
        borderColor: chartColors.sky,
        backgroundColor: "rgba(56, 189, 248, 0.12)",
        fill: true,
        tension: 0.3,
        pointRadius: 0,
      },
      {
        label: "Balance",
        data: history.map((h) => h.balance),
        borderColor: chartColors.amber,
        borderDash: [4, 4],
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  };
  return (
    <div className="h-64">
      <Line data={data} options={baseLineOptions("USD")} />
    </div>
  );
}
